// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1054":"6ac84ec1","2995":"6ac84ec1","6751":"100065f3"}[chunkId] + ".chunk.css";
};